import { render, staticRenderFns } from "./use-case-registration.vue?vue&type=template&id=2e17cc6c&scoped=true"
import script from "./use-case-registration.vue?vue&type=script&lang=js"
export * from "./use-case-registration.vue?vue&type=script&lang=js"
import style0 from "./use-case-registration.vue?vue&type=style&index=0&id=2e17cc6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e17cc6c",
  null
  
)

export default component.exports